import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slice/authSlice';
import resendOtpReducer from './slice/resendOtpSlice';
import linkListReducer from './slice/LinkList';
import planListReducer from './slice/PlanList';
import linkAnalysisReducer from './slice/LinkAnalysis';
import QrCodeReducer from './slice/QRCode';
import bioLinkDetailsReducer from './slice/BioLinkPageDetails'
import biolinkQRCodeReducer from './slice/BiolinkQRCode';
import userBioLinkDetailsReducer from './slice/UserBioLinkDetails';
import followerListReducer from './slice/FollowersList';
import dashboardCountReducer from './slice/Dashboard';
import ProfileAnalyticsReducer from './slice/ProfileAnalytics';
import YoutubeAnalyticsReducer from './slice/YoutubeAnalytic';
import SocialAnalyticsReducer from './slice/SocialAnalytic';
import AdvertiseImageReducer from './slice/AdvertisementImage';
import ProfileDetailsReducer from './slice/ProfileDetails';
import countryListReducer from './slice/CountryList';
import masterLinkListReducer from './slice/MasterLinkList';
import chatNotificationReducer from './slice/ChatNotification';
import userFilterReducer from './slice/UserFilter';
import ipReportStatusReducer from './slice/IPReportStatus';
import videoAnalysisReducer from './slice/VideoAnalytics';
import buttonAnalysisReducer from './slice/ButtonAnalytics';
import biolinkPlanList from './slice/BioLinkPlan';
import starRatingWebReducer from './slice/StarRatingWeb'
import unreadChatListReducer from './slice/UnreadChatList'
import paymentHistoryReducer from './slice/PaymentHistory'
import citySearchReducer from './slice/CitySearch'
import chatLockUnlockStatusReducer from './slice/ChatLockUnlockStatus'
import cityStateGstReducer from './slice/CityStateGst'
import certificateListReducer from './slice/CertificateList'
import faqListReducer from './slice/FaqList'
import notificationListReducer from './slice/NotificationList'
export const store = configureStore({
  reducer: {
    auth: authReducer,
    resendOtp: resendOtpReducer,
    dashboardCount: dashboardCountReducer,
    linkList: linkListReducer,
    planList: planListReducer,
    biolinkPlanList: biolinkPlanList,
    linkAnalysis: linkAnalysisReducer,
    qrCode: QrCodeReducer,
    bioLinkDetails: bioLinkDetailsReducer,
    biolinkQRCode: biolinkQRCodeReducer,
    userBioLinkDetails: userBioLinkDetailsReducer,
    followerList: followerListReducer,
    profileAnalytics: ProfileAnalyticsReducer,
    youtubeAnalytics: YoutubeAnalyticsReducer,
    socialAnalytics: SocialAnalyticsReducer,
    advertiseImage: AdvertiseImageReducer,
    profileDetails: ProfileDetailsReducer,
    countryList: countryListReducer,
    masterLinkLink: masterLinkListReducer,
    chatNotification: chatNotificationReducer,
    userFilter: userFilterReducer,
    ipReportStatus: ipReportStatusReducer,
    videoAnalysis: videoAnalysisReducer,
    buttonAnalysis: buttonAnalysisReducer,
    starRatingWeb: starRatingWebReducer,
    unreadChatList: unreadChatListReducer,
    paymentHistory: paymentHistoryReducer,
    citySearch: citySearchReducer,
    cityStateGst: cityStateGstReducer,
    chatLockUnlockStatus: chatLockUnlockStatusReducer,
    certificateList: certificateListReducer,
    faqList: faqListReducer,
    notificationList: notificationListReducer,

  },
});

export default store;